export const typography = {
  fontFamily: "HiltonSans",

  h1: {
    fontFamily: "HiltonSerif",
    fontSize: "52px",
    fontWeight: "400",
    lineHeight: "65px"
  },
  h2: {
    fontFamily: "HiltonSerif",
    fontSize: "40px",
    fontWeight: "400",
    lineHeight: "50px"
  },
  h3: {
    fontFamily: "HiltonSerif",
    fontSize: "32px",
    fontWeight: "400",
    lineHeight: "40px"
  },
  h4: {
    fontFamily: "HiltonSerif",
    fontSize: "26px",
    fontWeight: "400",
    lineHeight: "33px"
  },
  h5: {
    fontFamily: "HiltonSerif",
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "25px"
  },
  body1: {
    fontFamily: "HiltonSans",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "22px"
  },
  body2: {
    fontFamily: "HiltonSans",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "21px"
  },
  label: {
    fontFamily: "HiltonSans",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "18px"
  }
};
